module.exports = __webpack_public_path__ + "img/close-icon.aec74593.svg";